import {IReduxModelConfigsState} from '@src/@interfaces';

const state: IReduxModelConfigsState = {
    listConfigs: {},
    formConfigs: {},
    importConfigs: {},
    nowLoadingModelConfigs: {},
    errors: {},
    updatedAt: 0,
};

export default state;
